import { render, staticRenderFns } from "./EditDropshipperActions.vue?vue&type=template&id=1a518c62&scoped=true"
import script from "./EditDropshipperActions.vue?vue&type=script&lang=js"
export * from "./EditDropshipperActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a518c62",
  null
  
)

export default component.exports